import { render, staticRenderFns } from "./block-user-tags.vue?vue&type=template&id=fa749bb2&scoped=true&lang=pug"
import script from "./block-user-tags.vue?vue&type=script&lang=js"
export * from "./block-user-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa749bb2",
  null
  
)

export default component.exports